import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikProps } from 'formik';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FamilyVM } from '../family/family-vm';
import AccordionPersonForm, { PersonFormVM } from './form';
import { useAireSubscription } from 'subscription/context/aire-subscription';

interface AccordionPersonProps {
  formContext: FormikProps<{
    family: Array<FamilyVM>;
    person?: PersonFormVM;
  }>;
}

const AccordionPersonComponent = ({ formContext }: AccordionPersonProps): React.ReactElement => {
  const { praticaKey } = useAireSubscription();

  const [open, setOpen] = useState(false);

  const onFieldPersonChange = useEventCallback(
    (key: keyof PersonFormVM, value: PersonFormVM[keyof PersonFormVM]) => {
      formContext.setFieldValue('person', {
        ...(formContext.values.person || {}),
        [key]: value,
      });
    }
  );

  const onFieldsPersonChanges = useEventCallback((values: PersonFormVM) => {
    formContext.setFieldValue('person', {
      ...(formContext.values.person || {}),
      ...values,
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Ci sono altre persone che si spostano?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionPersonForm
            values={formContext.values.person}
            onChange={onFieldPersonChange}
            onChangeFields={onFieldsPersonChanges}
            codeEnte={praticaKey?.cdEnte}
            yearId={praticaKey?.idAnnoPratica?.toString()}
            typeRegister="IAIRE"
            progressive={praticaKey?.pgPratica?.toString()}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionPersonComponent.displayName = 'Accordion person component';

const AccordionPerson = memo(AccordionPersonComponent);

export default AccordionPerson;
